import { Button } from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";
import i18n from "../i18n";
import styles from "./back-button.module.css";
import CaretLeft from "../images/caret-left.svg?react";

type BackButtonProps = {
	onBack: () => void;
	ariaLabel?: string;
	/**Text of the button @default "back" */
	variant?: "back" | "cancel";
};

export default function BackButton({ onBack, ariaLabel, variant = "back" }: BackButtonProps) {
	return (
		<Button
			variant="text"
			className={styles.button}
			onClick={onBack}
			startIcon={
				<SvgIcon>
					<CaretLeft />
				</SvgIcon>
			}
			aria-label={ariaLabel}
			disableFocusRipple
		>
			{variant === "back"
				? i18n.t("portal.components.backButtonTSX.back")
				: i18n.t("portal.components.backButtonTSX.cancel")}
		</Button>
	);
}
